import styled, { css } from 'styled-components';
import { colors, isDefaultThemeMode } from '../';

export const accessibilityBorder = (props) => !isDefaultThemeMode(props) && css`
  border: 1px solid ${colors.accent};
`;

export const accessibilityHoverInvert = (props) => !isDefaultThemeMode(props) && !props.disabled && css`
  &:hover {
    background-color: ${colors.text};
    color: ${colors.background};
  }
`;

export const accessibilityHoverInvertDark = (props) => !isDefaultThemeMode(props) && !props.disabled && css`
  &:hover {
    background-color: ${colors.background};
    color: ${colors.text};
  }
`;

export const VisuallyHidden = styled.span`
  clip: rect(0 0 0 0);
  height: 1px;
  width: 1px;
  margin: -1px;
  padding: 0;
  border: 0;
  overflow: hidden;
  position: absolute;
  visibility: hidden;
`;

export const KEY_SPACE = 32;
export const KEY_ENTER = 13;



// WEBPACK FOOTER //
// ./src/core/theme/components/accessibility.js